import { GetProjectByProjectIdIssueFormulaGroupIssuesApiResponse } from "../../../../../../../../openapi";

export type FormulaComparableIssue = {
  _id?: string;
  title?: string | null;
  bucket?: string | null;
  status?: string | null;
  otherAttributesData?: Record<string, string | number | boolean | null | (string | number | boolean | null)[]> | null;
};

export const normalizeFormulaValue = (value: unknown) => {
  if (Array.isArray(value)) {
    return JSON.stringify([...value].map((item) => (item == null ? null : String(item))).sort());
  }

  return value == null ? null : String(value);
};

export const getFormulaValue = (issue: FormulaComparableIssue, attributeKey: string) => {
  if (attributeKey === "title") return issue.title ?? "";
  if (attributeKey === "bucket") return issue.bucket ?? "";
  if (attributeKey === "status") return issue.status ?? "";

  return issue.otherAttributesData?.[attributeKey] ?? null;
};

export const getNextAvailableCounter = (values: number[]) => {
  const sortedValues = [...new Set(values)].sort((a, b) => a - b);
  let nextAvailable = 1;

  for (const value of sortedValues) {
    if (value === nextAvailable) {
      nextAvailable += 1;
      continue;
    }

    if (value > nextAvailable) break;
  }

  return nextAvailable;
};

export const getFormulaCounterSuggestions = (
  data: GetProjectByProjectIdIssueFormulaGroupIssuesApiResponse | undefined,
  formulaAttributeKey: string,
  minGapForNewSequence = 10,
) => {
  const values = [
    ...new Set(
      (data?.issues ?? [])
        .map((issue) => issue.formulaCounters?.[formulaAttributeKey]?.value)
        .filter((value): value is number => Number.isInteger(value) && value > 0),
    ),
  ].sort((a, b) => a - b);

  if (values.length === 0) return [1];

  const suggestions: number[] = [];
  let sequenceEnd = values[0];

  for (const value of values.slice(1)) {
    if (value - sequenceEnd >= minGapForNewSequence) {
      suggestions.push(sequenceEnd + 1);
    }

    sequenceEnd = value;
  }

  suggestions.push(sequenceEnd + 1);
  return suggestions;
};

export const formatCounter = (value: number | null, minLength: number) => {
  if (value == null) return "-";

  return String(value).padStart(minLength, "0");
};
